import { actionHelpers } from '../core';

export const getAccountsValueChanges = actionHelpers.createAction('GET_ACCOUNTS_VALUE_CHANGES');
export const getAccountsValueChangesSuccess = actionHelpers.createAction('GET_ACCOUNTS_VALUE_CHANGES_SUCCESS');
export const getAccountsValueChangesFailure = actionHelpers.createAction('GET_ACCOUNTS_VALUE_CHANGES_FAILURE');
